import React, { useState } from 'react'
import './style.css'
import ReactGPicker from 'react-gcolor-picker';

export default function ColorPick({ element, onChange, gradient, value }) {
  const [open, setOpen] = useState(false)

  return (
    <div tabIndex={0} onBlur={(e) => {
      if (e.currentTarget.contains(e.relatedTarget)) {
        return
      }
      setOpen(false)
    }}>
      <div className='Color' onClick={() => setOpen(true)}>{element}
        <div className={open ? 'Color_Con Color_Con_Open' : 'Color_Con'}>
          {open ?
            <ReactGPicker defaultColors={[]} gradient={gradient} solid={!gradient} value={value} onChange={onChange} />
            : null}
        </div>
      </div>
    </div>
  )
}